export const IoMdArrowDropRight = [
  {
    icon: {
      paths: ["M426 726v-428l214 214z"],
      attrs: [{}],
      isMulticolor: false,
      isMulticolor2: false,
      tags: ["arrow_right"],
      grid: 24
    },
    attrs: [{}],
    properties: {
      order: 1,
      id: 1,
      prevSize: 24,
      name: "arrow_right"
    },
    setIdx: 0,
    setId: 2,
    iconIdx: 0
  }
];
